import { UserContextStateType } from "./userContext";

export type UserActionType = {
  type: "SET_USER" | "SET_ROLES";
  payload: any;
};

export const userReducer = (
  state: UserContextStateType,
  action: UserActionType
) => {
  switch (action.type) {
    case "SET_USER":
      return {
        ...state,
        user: action.payload,
      };
    case "SET_ROLES":
      return {
        ...state,
        hasAdministratorRole: action.payload.includes("Administrator"),
        hasUserRole: action.payload.includes("User"),
        hasViewerRole: action.payload.includes("Viewer"),
        isLoading: false,
      };
    default:
      return state;
  }
};
